"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The row of figures summarizing a set of durations.
 *
 * One row, always. A fixed column count would wrap the moment the list of
 * percentiles grew, and the strip reads as a scale — a scale broken over two
 * lines is two scales. Flex with an equal basis divides whatever width there
 * is between however many figures there are, and the strip scrolls rather than
 * wrapping when there is not enough.
 */
const styles = exports.styles = {
  figureStrip: {
    display: "x78zum5",
    overflowX: "x1plvlek xm9l3w6",
    gap: "xxhr3t",
    rowGap: null,
    columnGap: null,
    marginTop: "xj1urod",
    marginBottom: "x1nhhxel",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "xomzojh",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "xk6p4me",
    boxShadow: "x9mbo3",
    $$css: true
  },
  figure: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    flexGrow: "x1iyjqo2",
    flexShrink: "xs83m0k",
    flexBasis: "x1r8uery",
    minWidth: "xeuugli x1eg7fdh",
    paddingLeft: "x15u6esi",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1arb9wb",
    marginTop: "x1tbvfm1",
    marginBottom: "x1hpqcdg",
    alignItems: "x6s0dn4",
    textAlign: "x2b8uid",
    justifyContent: "xl56j7k",
    $$css: true
  },
  figureDivider: {
    width: "x1i1rx1s",
    flexGrow: "x1c4vz4f",
    flexShrink: "x2lah0s",
    alignSelf: "xkh2ocl",
    backgroundColor: "xnhdyh",
    marginLeft: "xuqiktq",
    marginInlineStart: null,
    marginInlineEnd: null,
    marginRight: "xdh7pzt",
    marginTop: "x1mjqqkp",
    marginBottom: "xhbfen4",
    $$css: true
  },
  figureValue: {
    fontSize: "x10n9v0i",
    whiteSpace: "xuxw1ft",
    fontFamily: "xm3uy08",
    color: "x10kmngs",
    $$css: true
  },
  figureEmphasized: {
    backgroundColor: "xwyle2k",
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingTop: "x6dzris",
    paddingBottom: "x1uwplc6",
    $$css: true
  },
  figureValueEmphasized: {
    fontSize: "x1l6gwhu",
    fontWeight: "x1s688f",
    $$css: true
  },
  figureLabelEmphasized: {
    color: "x10kmngs",
    fontWeight: "x1s688f",
    $$css: true
  }
};